/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskUnauthorizedError
 */
export interface ExecRiskUnauthorizedError {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskUnauthorizedError
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskUnauthorizedError
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskUnauthorizedError
     */
    message: string;
}

/**
 * Check if a given object implements the ExecRiskUnauthorizedError interface.
 */
export function instanceOfExecRiskUnauthorizedError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function ExecRiskUnauthorizedErrorFromJSON(json: any): ExecRiskUnauthorizedError {
    return ExecRiskUnauthorizedErrorFromJSONTyped(json, false);
}

export function ExecRiskUnauthorizedErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskUnauthorizedError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'title': json['title'],
        'message': json['message'],
    };
}

export function ExecRiskUnauthorizedErrorToJSON(value?: ExecRiskUnauthorizedError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'title': value.title,
        'message': value.message,
    };
}

